import CsrfCookieController from '@/types/wayfinder/actions/App/Http/Controllers/Web/CsrfCookieController';
import { getCsrfToken } from '@/utils/csrf';
import { http, type HttpRequestConfig } from '@inertiajs/core';

let pendingCookieRequest: Promise<void> | undefined;

function fetchXsrfCookie(): Promise<void> {
    pendingCookieRequest ??= fetch(CsrfCookieController.url(), { credentials: 'same-origin' })
        .then((): void => undefined)
        // A failed fetch still lets the write go out; the server answers it like before.
        .catch((): void => undefined)
        .finally((): void => {
            pendingCookieRequest = undefined;
        });

    return pendingCookieRequest;
}

/** CDN-cached pages ship without cookies, so every request waits for one shared session before it can 419 or fork it. */
export async function ensureXsrfCookie(config: HttpRequestConfig): Promise<HttpRequestConfig> {
    if (getCsrfToken() === '') {
        await fetchXsrfCookie();
    }

    return config;
}

export function registerXsrfCookieGuard(): void {
    http.onRequest(ensureXsrfCookie);
}
